export default __webpack_public_path__ + "static/media/logo-oxone-black.f15dec59.svg";